import React, { useCallback, useEffect, useState } from 'react';
import UserPaneHeader from '../UserPaneHeader';
import { titles } from '../../settings';
import { useUser } from '../../Connectable.hooks';
import { usePrivileges } from '@/app/state/auth/index.hooks';
import { useDispatch } from 'react-redux';
import { deselectUser } from '@/app/state/ui/usersSlice';
import { RolesSection } from './RolesSection';
import { GeneralInfoSection } from './GeneralInfoSection';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import { ReportsSection } from './ReportsSection';
import { restGetUserReportAssignments } from '@/app/services/reports';

const UserPreview = () => {
    const {
        setRightUser,
        editUser,
        deleteUser,
        changeUserPassword,
        manageReportDefinitionsAssignment,
    } = usePrivileges();
    const user = useUser();
    const dispatch = useDispatch();
    const [reportNames, setReportNames] = useState<string>();

    const handleClose = () => {
        dispatch(deselectUser());
    };

    const handleUpdate = () => {
        if (manageReportDefinitionsAssignment) {
            readUserReportsAssignment();
        }
    };

    const readUserReportsAssignment = useCallback(() => {
        if (user) {
            restGetUserReportAssignments(user.id).then((res) => {
                const names =
                    res
                        ?.sort((a, b) => a.name.localeCompare(b.name))
                        .map((role) => role.name)
                        .join(', ') ?? '';
                setReportNames(names);
            });
        }
    }, [user]);

    useEffect(() => {
        if (user && manageReportDefinitionsAssignment) {
            readUserReportsAssignment();
        }
    }, [manageReportDefinitionsAssignment, readUserReportsAssignment, user]);

    return (
        <Paper sx={{ display: 'flex', height: '100%' }}>
            <Box
                sx={{
                    display: 'flex',
                    position: 'relative',
                    flexGrow: 1,
                    flexDirection: 'column',
                    overflow: 'hidden',
                }}
            >
                {user && (
                    <>
                        <UserPaneHeader
                            user={user}
                            title={titles.preview()}
                            userDataRightEnabled={setRightUser}
                            editionEnabled={editUser}
                            deletionEnabled={deleteUser}
                            passwordResetEnabled={changeUserPassword}
                            onClose={handleClose}
                            onUpdate={handleUpdate}
                        />
                        <GeneralInfoSection user={user} />
                        <RolesSection roleIds={user.roles ?? []} />
                        {manageReportDefinitionsAssignment && (
                            <ReportsSection reportNames={reportNames ?? ''} />
                        )}
                    </>
                )}
            </Box>
        </Paper>
    );
};

export default UserPreview;
